/* eslint-disable react-hooks/exhaustive-deps */
import Dropdown from 'react-dropdown'
import React, { useState, useEffect } from 'react'

var outsideOutput = ''

const Support = (props) => {

    const [ supportType, setSupportType ] = useState('selectMe')
    const [ textMaker, setTextMaker ] = useState('none')
    const [ supportMaker, setSupportMaker ] = useState('none')
    const [ support, setSupport ] = useState(0)
    const [ supportArea, setSupportArea ] = useState(null)
    const [ supportComment, setSupportComment ] = useState('')
    const [ list, setList ] = useState([])


    const handleSupportComment = (e) => {
        setSupportComment(e.target.value)
    }

    // dropdown menu selection function
    const onSelectSupport = (e) => {
        setSupportType(e.value)
        setSupportMaker(e.value)
    }

    // let mySuperSupportList = [
    //     'none',
    //     'Late Wave Payment',
    //     'Additional Support',
    //     'Seasonal Incentive',
    //     'DPMO Incentive',
    //     'Support',
    //     'Performance Bonus',
    //     'TOLL'
    // ]

    // handle only allowing one
    useEffect( () => {
        props.supportTracking(supportType)
        outsideOutput = supportType
    }, [supportType])

    // handle the input changes
    const handleChangeInputs = (e) => {
        if (outsideOutput !== "TOLL" && outsideOutput !== "R2" && outsideOutput !== 'R4' && outsideOutput !== "R6") {
            setSupport(e.target.value)
        }
    }

    useEffect( () => {
        if (supportMaker !== 'none') {
            setSupportArea(
                <textarea onChange={handleSupportComment} rows="4" cols="50" id='deduction_textarea'>
                    {supportComment}
                </textarea>
            )
        } else {
            setSupportArea(null)
        }
    }, [supportMaker, supportComment])

    useEffect( () => {
        props.dataEntered(supportType, support, supportComment, props.index)
    }, [supportType, support, supportComment])

    useEffect( () => {
        if (supportType !== 'selectMe') {
            setList([])
        } else {
            let localList = [...props.allowedList]
            if (!localList.includes('R2')) {
                localList.push('R2')
            }
            if (!localList.includes('R4')) {
                localList.push('R4')
            }
            if (!localList.includes('R6')) {
                localList.push('R6')
            }
            setList(localList)
        }
    }, [supportType])

    useEffect( () => {
        switch (supportType) {
            case 'TOLL':
                setSupport(2)
                break;
            case 'R2':
                setSupport(35.25)
                break;
            case 'R4':
                setSupport(68.35)
                break;
            case 'R6':
                setSupport(101.43)
                break;
            default:
                break;
        }
    }, [supportType])

    return (
        <>
            <div className='dashboard_form_divs_texty'>  
                <div>
                    <label className='dashboard_labels'>Support </label>        
                </div>
                <div className='solve_this'>
                    <div>
                        <Dropdown 
                            options={list} 
                            onChange={onSelectSupport} 
                            value={supportType} 
                            placeholder="Select an option" 
                            className='drop_down_bar_dashboard'
                            id='drop_down_style'
                        />
                        <input className='input_dashboard_page' type="text" name='support' value={support} onChange={handleChangeInputs}/>
                        {supportArea}
                    </div>
                </div>  
            </div>
        </>
    )
}

export default Support